import { render, staticRenderFns } from "./myorderDetail.vue?vue&type=template&id=0741600b&scoped=true&"
import script from "./myorderDetail.vue?vue&type=script&lang=js&"
export * from "./myorderDetail.vue?vue&type=script&lang=js&"
import style0 from "./myorderDetail.vue?vue&type=style&index=0&id=0741600b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0741600b",
  null
  
)

export default component.exports